import { ErrorHandler, Injectable } from '@angular/core';
import { AuditoriaAccion } from '@enum/auditoria/auditoria-keys.enum';
import { InscripcionTraceService } from './inscripcion-trace.service';

/**
 * Captura cualquier error no manejado de Angular y lo deja en la traza de
 * inscripción, para poder diagnosticar fallos esporádicos en producción.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

    constructor(private inscripcionTrace: InscripcionTraceService) {}

    handleError(error: any): void {
        try {
            this.inscripcionTrace.logError(AuditoriaAccion.GLOBAL_ERROR, error, {
                paso: 'ErrorHandler Angular',
            });
        } catch {
            // Nunca volver a lanzar desde el handler global.
        }
        // Preservar el log nativo (sobrevive en prod, console.error no se silencia).
        console.error(error);
    }
}
